import React, { useState, useEffect, useContext } from "react";
import { Tabs } from "antd-mobile";
import { AuthContext } from "../context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { BsBuildings } from "react-icons/bs";
import { GoPerson } from "react-icons/go";
import { FcMoneyTransfer } from "react-icons/fc";
import { InfoDataStatistique } from "../Entities";
import { DatePicker } from "antd";
import * as dayjs from "dayjs";
import BlocStatistiques from "./Statistiques/BlocStatistiques";
import { fectchBiens } from "../store/slice/BiensSlice";
import FiltreWithTemplate from "../features/accueil/FiltreWithTemplate";
// import { fectchClients } from "../store/slice/ClientsSlice";
// import { fectchProprietaire } from "../store/slice/ProprietaireSlice";
// import { spinnerReducer } from "../store/slice/Loading/SpinnerSlice";
import {
  fectchStatistiqueBiensLocation,
  fectchStatistiqueBiensVente,
  fectchStatistiqueTerrainVente,
} from "../store/slice/StatistiqueSlice";
// import LoadingSpinner from "../shared/compoments/LoadingSpinner";
import { fectchPrevisionGlobale } from "../store/slice/proprietes/PrevisionsGlobale";
import { fectchRevenuGlobale } from "../store/slice/proprietes/RevenusGlobale";
import { fectchRecouvrementGlobale } from "../store/slice/proprietes/RecouvrementGlobale";

import { fectchProprietesVenteMaison } from "../store/slice/proprietes/ProprietesVenteMaison";
import { fectchProprietesLocationsMaison } from "../store/slice/proprietes/ProprieteLocationMaison";
import TypesOfStatistique from "./Statistiques/TypesOfStatistique";
import { fectchProprietesVenteTerrain } from "../store/slice/proprietes/ProprietesVenteTerrain";
import { useCallback } from "react";
dayjs().format();

const Icone = {
  biens: <BsBuildings fontSize={"2em"} color={"green"} />,
  Clients: <GoPerson fontSize={"2em"} color={"orange"} />,
  Montant: <FcMoneyTransfer fontSize={"2em"} />,
};

function Accueil() {
  const { user } = useContext(AuthContext);
  const dispatch = useDispatch();
  const [filtreWithPeriodeAndYear, setFiltreWithPeriodeAndYear] =
    useState("year");
  const [typePeriodeFilter, setTypePeriodeFilter] =
    useState("Maison en location");
  const [filtreBiensWithPeriodeAndYear, setFiltreBiensWithPeriodeAndYear] =
    useState("year");
  const [getYear, setGetYear] = useState(dayjs());
  const [data, setData] = useState({ date_debut: "", date_fin: "" });
  const [dataBien, setDataBien] = useState({ date_debut: "", date_fin: "" });
  const [getYearFilterNbreTotal, setGetYearFilterNbreTotal] = useState(dayjs());
  const onChange = (date) => {
    console.log(date.$y);
    const element = String(date.$y);
    setGetYear(dayjs(element));
  };
  const onChangeNbreBiens = (date) => {
    console.log("onChangeNbreBiens", date.$y);
    const element = String(date.$y);
    setGetYearFilterNbreTotal(dayjs(element));
  };

  // const showLoading = useSelector((state) => state.spinnerReducer.isLoading);

  const totalBiens = useSelector((state) => state.biensReducer.totalBiens);
  const totalBiensIndisponible = useSelector(
    (state) => state.biensReducer.totalBiensIndisponible
  );
  const totalBiensVendus = useSelector(
    (state) => state.biensReducer.totalBiensVendus
  );
  const totalBiensLouer = useSelector(
    (state) => state.biensReducer.totalBiensLouer
  );

  // const totalClients = useSelector(
  //   (state) => state.clientsReducer.totalClients
  // );
  // const totalProprietaire = useSelector(
  //   (state) => state.proprietaireReducer.totalProprietaire
  // );

  const previsionsGlobaleStatistique = useSelector(
    (state) => state.previsionsGlobaleReducer.data_prevision
  );
  const montantDormantStatistique = useSelector(
    (state) => state.previsionsGlobaleReducer.data_Montant_dormant
  );

  const revenusGlobaleStatistique = useSelector(
    (state) => state.revenuGlobaleReducer.data_revenu
  );

  const recouvrementGlobaleStatistique = useSelector(
    (state) => state.recouvrementGlobaleReducer.data_recouvrement
  );

  const infoDataNbreTotal = [
    new InfoDataStatistique(
      "Indisponibles",
      totalBiensIndisponible,
      Icone["biens"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      "Disponibles",
      totalBiens,
      Icone["biens"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      "Occupés",
      totalBiensLouer,
      Icone["biens"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      "Vendus",
      totalBiensVendus,
      Icone["biens"]
    ).handleInfoDataStatistique(),
    // new InfoDataStatistique(
    //   "Clients",
    //   totalClients,
    //   Icone["Clients"]
    // ).handleInfoDataStatistique(),
    // new InfoDataStatistique(
    //   "Propriétaires",
    //   totalProprietaire,
    //   Icone["Clients"]
    // ).handleInfoDataStatistique(),
  ];
  const infoDataFinance = [
    new InfoDataStatistique(
      "Revenu dormant",
      montantDormantStatistique,
      Icone["Montant"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      "Prévisions",
      // "Portefeuille global",
      previsionsGlobaleStatistique,
      Icone["Montant"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      // "Revenus",
      "Revenu actif",
      revenusGlobaleStatistique,
      Icone["Montant"]
    ).handleInfoDataStatistique(),
    new InfoDataStatistique(
      "Recouvrement",
      recouvrementGlobaleStatistique,
      Icone["Montant"]
    ).handleInfoDataStatistique(),
  ];
  const handleDispatch = useCallback(() => {
    dispatch(fectchStatistiqueBiensLocation(getYear.$y));
    dispatch(fectchStatistiqueBiensVente(getYear.$y));
    dispatch(fectchStatistiqueTerrainVente(getYear.$y));
    dispatch(fectchProprietesVenteMaison(getYear.$y));
    dispatch(fectchProprietesLocationsMaison(getYear.$y));
    dispatch(fectchProprietesVenteTerrain(getYear.$y));
  }, [getYear, dispatch]);

  const callAllDispatch = useCallback(() => {
    dispatch(fectchBiens(getYearFilterNbreTotal));
    dispatch(fectchPrevisionGlobale(getYearFilterNbreTotal));
    dispatch(fectchRevenuGlobale(getYearFilterNbreTotal));
    dispatch(fectchRecouvrementGlobale(getYearFilterNbreTotal));
  }, [dispatch, getYearFilterNbreTotal]);

  useEffect(() => {
    handleDispatch();
  }, [handleDispatch]);

  useEffect(() => {
    callAllDispatch();
  }, [callAllDispatch]);

  return (
    <div className="conteneur-page">
      <h1 style={{ fontSize: "32px" }}>Tableau de bord</h1>
      <h6 className="my-3">
        Bienvenue{" "}
        <span className="text-secondary">
          {user.nom} {user.prenom}
        </span>
      </h6>

      <Tabs stretch={false}>
        <Tabs.Tab title="Biens" key="Biens">
          <div style={{ position: "relative" }}>
            <SelectedBiens
              dataBien={dataBien}
              setDataBien={setDataBien}
              handleMethod={onChangeNbreBiens}
              getYear={getYearFilterNbreTotal}
              filtreBiensWithPeriodeAndYear={filtreBiensWithPeriodeAndYear}
              setFiltreBiensWithPeriodeAndYear={
                setFiltreBiensWithPeriodeAndYear
              }
            />
            <BlocStatistiques dataInfo={infoDataNbreTotal} />
            <section
              style={{ justifyContent: "flex-end" }}
              className="d-flex align-items-center gap-3 my-3 flex-wrap">
              <SelectedOptions
                defaultValue={typePeriodeFilter}
                idName={"stat-filter2"}
                handleOnChange={(e) => setTypePeriodeFilter(e.target.value)}
                infoDataOptions={[
                  {
                    libelle: "Maison en location",
                    value: "Maison en location",
                  },
                  { libelle: "Maison en vente", value: "Maison en vente" },
                  {
                    libelle: "Terrain en vente",
                    value: "Terrain en vente",
                  },
                ]}
              />
              <select
                className="select-filter p-2 m-0 rounded-0"
                name=""
                id=""
                defaultValue={filtreWithPeriodeAndYear}
                onChange={(e) => setFiltreWithPeriodeAndYear(e.target.value)}>
                <option value="year">Année</option>
                <option value="periode">Période</option>
              </select>
              <FiltreWithTemplate
                getYear={getYear}
                onChange={onChange}
                filtreWith={filtreWithPeriodeAndYear}
                setData={setData}
                data={data}
              />
            </section>
            <section>
              <TypesOfStatistique
                isBienOrFinance={"biens"}
                typePeriodeFilter={typePeriodeFilter}
              />
            </section>
          </div>
        </Tabs.Tab>
        <Tabs.Tab title="Finances" key="Finances">
          <div style={{ position: "relative" }}>
            <SelectedBiens
              dataBien={dataBien}
              setDataBien={setDataBien}
              setFiltreBiensWithPeriodeAndYear={
                setFiltreBiensWithPeriodeAndYear
              }
              filtreBiensWithPeriodeAndYear={filtreBiensWithPeriodeAndYear}
              handleMethod={onChangeNbreBiens}
              getYear={getYearFilterNbreTotal}
            />
            {/* {showLoading && <LoadingSpinner />} */}
            <BlocStatistiques dataInfo={infoDataFinance} />
            <section
              style={{ justifyContent: "flex-end" }}
              className="d-flex align-items-center gap-3 my-3 flex-wrap">
              <SelectedOptions
                defaultValue={typePeriodeFilter}
                idName={"stat-filter2"}
                handleOnChange={(e) => setTypePeriodeFilter(e.target.value)}
                infoDataOptions={[
                  {
                    libelle: "Maison en location",
                    value: "Maison en location",
                  },
                  { libelle: "Maison en vente", value: "Maison en vente" },
                  {
                    libelle: "Terrain en vente",
                    value: "Terrain en vente",
                  },
                ]}
              />
              <select
                className="select-filter p-2 m-0 rounded-0"
                name=""
                id=""
                defaultValue={filtreWithPeriodeAndYear}
                onChange={(e) => setFiltreWithPeriodeAndYear(e.target.value)}>
                <option value="year">Année</option>
                <option value="periode">Période</option>
              </select>
              <FiltreWithTemplate
                getYear={getYear}
                onChange={onChange}
                filtreWith={filtreWithPeriodeAndYear}
                setData={setData}
                data={data}
              />
            </section>
            <section>
              <TypesOfStatistique
                isBienOrFinance={"finances"}
                typePeriodeFilter={typePeriodeFilter}
              />
            </section>
          </div>
        </Tabs.Tab>
      </Tabs>
    </div>
  );
}

const SelectedBiens = ({
  handleMethod,
  getYear,
  filtreBiensWithPeriodeAndYear,
  setFiltreBiensWithPeriodeAndYear,
  dataBien,
  setDataBien,
}) => {
  return (
    <section
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}>
      <select
        style={{
          height: "auto",
          margin: "0 1em",
          padding: ".5em",
        }}
        defaultValue={filtreBiensWithPeriodeAndYear}
        onChange={(e) => setFiltreBiensWithPeriodeAndYear(e.target.value)}>
        <option value="year">Année</option>
        <option value="periode">Période</option>
      </select>
      {filtreBiensWithPeriodeAndYear === "year" && (
        <DatePicker
          allowClear={false}
          onChange={handleMethod}
          value={getYear}
          picker="year"
        />
      )}
      {filtreBiensWithPeriodeAndYear === "periode" && (
        <section className="d-flex gap-2 align-items-center">
          <input
            min={new Date().toISOString().slice(0, 10)}
            style={{ width: "auto", height: "20px" }}
            type="date"
            onChange={(e) =>
              setDataBien({ ...dataBien, date_debut: e.target.value })
            }
            value={dataBien.date_debut}
          />
          <span>Au</span>
          <input
            style={{ width: "auto", height: "20px" }}
            type="date"
            onChange={(e) =>
              setDataBien({ ...dataBien, date_fin: e.target.value })
            }
            value={dataBien.date_fin}
          />
        </section>
      )}
    </section>
  );
};

const SelectedOptions = ({
  handleOnChange,
  defaultValue,
  infoDataOptions,
  idName,
}) => {
  return (
    <select
      name="filter"
      id={idName}
      className="select-filter p-2 m-0 rounded-0"
      defaultValue={defaultValue}
      onChange={handleOnChange}>
      {infoDataOptions.map((item, index) => (
        <option key={index} value={item.value}>
          {item.libelle}
        </option>
      ))}
    </select>
  );
};

export default Accueil;
